/*
*   File : performance.js
*   Author : https://evoqins.com
*   Description : Performance data page
*   Integrations : NA
*   Version : 1.0.0
*/

import React from 'react';
import { MultiLineChart } from '../../../Component/Chart';


const Performance = (props) => {
    return (
        // <div className={`${props.subscription === true ? "" : "overflow-hidden h-400"} position-relative`}>
        <div>

            <div className='mt-4'>

                <div className="mb-4">
                    <h6 className='e-text-black e-primary-font-clash-display e-font-16 e-font-weight-500 line-height-24px mb-4'>
                        Historical Performance
                    </h6>

                    <p className='e-text-outer-space e-alt-font-lato e-font-14 e-font-weight-600 line-height-16px mb-4 e-letter-spacing-min-point-2px mb-4'>
                        Benchmark: {props.benchmark}
                    </p>
                    {/* Multi line Chart */}
                    <MultiLineChart
                        labels={props.data.labels}
                        dataset1={props.data.dataset1}
                        dataset2={props.data.dataset2}
                        borderColor1="#523FC0"
                        borderColor2="#47FFFF"
                        legend2Label={props.benchmark} />
                </div>

                <div className="">
                    <h6 className='e-text-black e-primary-font-clash-display e-font-16 e-font-weight-500 line-height-24px mb-2'>
                        CAGR Performance
                    </h6>
                    <div id='basket-details-performance-cagr'>
                        <div className="bg-white p-3 d-flex border-radius-8 flex-wrap row-gap-3">
                            {
                                props.cagrPerformance.map((item, index) => (
                                    <p className='d-flex flex-column gap-2 col-3 mb-0' key={index}>
                                        <span className='e-text-primary-color e-alt-font-lato  e-font-14 e-font-weight-500 line-height-18px'>
                                            {item.date}
                                        </span>
                                        <span className={`${item.value < 0 ? "e-text-red" : "e-text-islamic-green"}  e-text-primary-color e-alt-font-lato  e-font-16 e-font-weight-600 line-height-20px`}>
                                            {item.value}%
                                        </span>
                                    </p>
                                ))
                            }
                        </div>
                    </div>
                </div>

            </div>

            {/* Subscription overlay */}
            {
                // props.subscription === false &&
                // <div className='subscription-overlay position-absolute top-0 start-0 padding-50px-top text-center w-100 h-100'>
                //     <img src={require("../../../Assets/Images/Basket/lock.png")}
                //         draggable={false}
                //         width={96}
                //         height={148}
                //         className='mt-5'
                //         alt='portfolio border' />

                //     <h4 className='col-sm-8 col-md-7 col-lg-6 mx-auto text-center padding-26px-top mb-1 e-text-primary-color e-primary-font-clash-display e-font-16 e-font-weight-500 line-height-22px'>
                //         Subscribe to view  full holdings and see all your investments in detail
                //     </h4>
                //     <PrimaryButton name="Subscribe"
                //         className="col-auto px-5 h-48 mt-3"
                //         onPress={props.handleSubscribe} />
                // </div>
            }
        </div>
    )
}

export default Performance;
